import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-note",
  "use": "icon-note-usage",
  "viewBox": "0 0 14 16",
  "content": "<symbol viewBox=\"0 0 14 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-note\">\n<path d=\"M12.625 5.75H8.125V1.25H1.375V14.75H12.625V5.75ZM12.1683 4.625L9.25 1.70675V4.625H12.1683ZM0.8125 0.125H9.25L13.75 4.625V15.3125C13.75 15.4768 13.6973 15.6116 13.5919 15.7169C13.4866 15.8223 13.3518 15.875 13.1875 15.875H0.8125C0.64825 15.875 0.513438 15.8223 0.408063 15.7169C0.302688 15.6116 0.25 15.4768 0.25 15.3125V0.6875C0.25 0.52325 0.302688 0.388437 0.408063 0.283062C0.513438 0.177687 0.64825 0.125 0.8125 0.125ZM3.625 8H10.375V9.125H3.625V8ZM3.625 4.625H6.4375V5.75H3.625V4.625ZM3.625 11.375H10.375V12.5H3.625V11.375Z\" fill=\"#303133\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/note.svg
// module id = Ht9E
// module chunks = 262